import { useTranslation } from "react-i18next";
import { useEffect, useState, useRef } from 'react';
import '../../styles/game/GameLimits.css';
import '../../styles/game/howToPlay.css';
import '../../styles/game/BetsHistory.css';


function BetsHistory({ isOpen, onClose, BetsHistoryOpen, isUserId }) {
    const [isVisible, setIsVisible] = useState(false);
    const { t } = useTranslation();
    const [isMyBets, setIsMyBets] = useState([]);
    const [isLimits, setIsLimits] = useState(50);
    const [isLoading, setIsLoading] = useState(true);
    const [fetchButton, setFetchButton] = useState(true)

    useEffect(() => {
        if (isOpen) {
            setTimeout(() => setIsVisible(true), 10);
        } else {
            setIsVisible(false);
        }
    }, [isOpen]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setTimeout(() => setIsVisible(false), 10);
                onClose();
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);



    useEffect(() => {
        const fetchMyBetsHistory = async () => {
            try {
                const response = await fetch(`${import.meta.env.VITE_API_URL}/api/my-bets`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ userId: isUserId }), // Передаем userId в теле запроса
                });

                if (!response.ok) {
                    throw new Error(`Ошибка HTTP: ${response.status}`);
                }

                const data = await response.json(); // Парсим ответ
                // console.log(data)
                if(data.result) {
                    setIsMyBets(data.result)
                    setIsLoading(false)
                } // Сохраняем данные в состоянии
            } catch (error) {
                console.error('Ошибка при выполнении запроса:', error);
            }
        };

        fetchMyBetsHistory();
        
    }, [isUserId]); // Добавляем isUserId в зависимости



        const fetchMyBetsHistory = async () => {

            try {
                const response = await fetch(`${import.meta.env.VITE_API_URL}/api/my-bets-all`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ userId: isUserId, limit: isLimits }), // Передаем userId в теле запроса
                });

                if (!response.ok) {
                    throw new Error(`Ошибка HTTP: ${response.status}`);
                }

                const data = await response.json(); // Парсим ответ
                
                if(data.result) {
                    setIsMyBets(data.result)
                    // console.log(data.result)
                    setIsLoading(false)
                } // Сохраняем данные в состоянии
            } catch (error) {
                console.error('Ошибка при выполнении запроса:', error);
            }
        };


        
        

        function betDays(date) {
            const [datePart, timePart] = date.split('T');
            const [year, month, day] = datePart.split('-');
            const reformattedDate = `${day}-${month}-${year[2]}${year[3]}`;
    
            return reformattedDate 
        }
    
        function betTime(date) {
            const [datePart, timePart] = date.split('T');
    
            const time = `${timePart.split(':')[0]}:${timePart.split(':')[1]}`;
            
            return time
        }



    return (
        <>
            <div className={`modalWrapper ${isVisible ? "show" : "fade-out"}`}
                 onClick={() => {
                     setTimeout(() => setIsVisible(false), 10);
                     onClose();
                 }}>
            </div>
            <div className={`gameRulesModal ${isVisible ? "show" : "fade-out"}`} onClick={() => {
                setTimeout(() => setIsVisible(false), 10);
                onClose();
            }}>
                <div className={`gameLimitsWrapper ${isVisible ? "show" : "fade"}`}>
                    <div className={'gameRulesContent'} onClick={(e) => e.stopPropagation()}>
                        <div className={'gameRulesHeader'}>
                            <span>MY BET HISTORY</span>
                            <button className={'gameRulesCloseBtn'} onClick={() => {
                                setTimeout(() => setIsVisible(false), 10);
                                onClose();
                            }}>
                                <span>×</span>
                            </button>
                        </div>
                        <div className={'my-bet-modal-body'}>
                            <div className={'my-bet-modal-list'}>
                                <div className={'my-bet-modal-list-title'}>
                                    <div className={'my-bet-modal-date'}>Date</div>
                                    <div className={'my-bet-modal-bet'}>Bet USD</div>
                                    <div className={'my-bet-modal-multiplier'}>X</div>
                                    <div className={'my-bet-modal-cash-out'}>Cash out USD</div>
                                    <div className={'my-bet-modal-tools'}></div>
                                </div>
                                <div className={'my-bet-modal-list-body'}>

                                {isMyBets.length > 0 ? (
                        isMyBets.map((bet, index) => (
                        <div key={index} className={`my-bet-item-wrap ${bet.celebrated ? "celebrated" : ""}`}>
                        
                
                    <div className={'my-bet-item-date'}>
                        <div>{betTime(bet.createdAt)}</div>
                        <div>{betDays(bet.createdAt)}</div>
                    </div>
                    <div className={'my-bet-item-bet'}>
                        <div>{bet.bet}</div>
                    </div>
                    <div className={'my-bet-item-multiplier'}>
                        <div>
                            <div className={'bubble-multiplier'}>{bet.celebrated ? bet.celebrated + "x" : bet.round.roundResult + "x"}</div>
                        </div>
                    </div>
                    <div className={'my-bet-item-cash-out'}>
                        <div>{bet.celebrated ? bet.cashout : ""}</div>
                    </div>
                    <div className={'my-bet-item-tools'}>
                        <div className={'my-bet-item-verify'}></div>
                        <div className={'my-bet-item-share'}></div>
                    </div>
                
            
                        </div>
        ))
    ) : ""
    // (
    //     <div className={`archive-loader-wrap show mybets-all`}>
    //     <span className={'archive-loader'}></span>
    //     </div>
    // )
    }

{/* 
                                    <div className={'my-bet-item-wrap'}>
                                        <div className={'my-bet-item-date'}>
                                            <div>06:39</div>
                                            <div>10-02-25</div>
                                        </div>
                                        <div className={'my-bet-item-bet'}>
                                            <div>1.00</div>
                                        </div>
                                        <div className={'my-bet-item-multiplier'}>
                                            <div>
                                                <div className={'bubble-multiplier'}>1.18x</div>
                                            </div>
                                        </div>
                                        <div className={'my-bet-item-cash-out'}>
                                            <div></div>
                                        </div>
                                        <div className={'my-bet-item-tools'}>
                                            <div className={'my-bet-item-verify'}></div>
                                            <div className={'my-bet-item-share'}></div>
                                        </div>
                                    </div> */}
                            {isLoading ? <div className={`archive-loader-wrap show mybets-all`}>
                                                <span className={'archive-loader'}></span>
                                            </div> : ""}

                                </div>
                            </div>
                            {isLoading ? "" : <div className={'my-bet-modal-footer'}>
                                <button className={'my-bet-load-more'} onClick={() => {
                                    setIsLoading(true)
                                    fetchMyBetsHistory()
                                    setFetchButton(false)
                                }} disabled={!fetchButton}>Load more</button>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BetsHistory;